import React from 'react';
import { useParams } from 'react-router-dom';
import { ClockIcon } from 'lucide-react';
import { usePageMeta } from '../../hooks/usePageMeta';
import { articles } from '../../data/insights';
import { formatDate } from '../../utils/format';
import { PageHero } from '../../components/ui/PageHero';
import { ArticleCard } from '../../components/insights/ArticleCard';
import { NewsletterForm } from '../../components/forms/NewsletterForm';
import { NotFound } from '../NotFound';
export function Article() {
  const {
    slug
  } = useParams();
  const article = articles.find(a => a.slug === slug);
  usePageMeta(article?.title ?? 'Article not found', article?.excerpt ?? 'This article could not be found.');
  if (!article) return <NotFound data-id="element-959" data-mp="5tubg1v2gxrx" />;
  const related = [...articles.filter(a => a.slug !== article.slug && a.category === article.category), ...articles.filter(a => a.slug !== article.slug && a.category !== article.category)].slice(0, 3);
  return <>
      <PageHero crumbs={[{
      label: 'Insights',
      to: '/insights'
    }, {
      label: article.category
    }]} kicker={article.category} title={article.title} intro={article.excerpt} data-id="element-960" data-mp="3r2fhbe1mxu16" />
      <section className="bg-white py-16 md:py-20" data-id="element-961" data-mp="4vi97ee041xf">
        <div className="container-page grid gap-12 lg:grid-cols-12" data-id="element-962" data-mp="4vqlb42av37k">
          <aside className="lg:col-span-3" data-id="element-963" data-mp="8x3vtrgc7ukt">
            <div className="space-y-3 border-t border-line pt-5 text-sm text-muted lg:sticky lg:top-28" data-id="element-964" data-mp="8uq0dhhqwgcq">
              <p className="flex items-center gap-2" data-id="element-965" data-mp="389utib0smf48">
                <ClockIcon className="h-4 w-4" aria-hidden="true" data-id="element-966" data-mp="3dc3lb41xjb4r" />
                {article.readMinutes} min read
              </p>
              <p data-id="element-967" data-mp="3hbcg8c8phf1w">{formatDate(article.date)}</p>
              <p data-id="element-968" data-mp="3m3vu7abb2c78">Corventa Talent Search</p>
            </div>
          </aside>
          <article className="prose-corventa max-w-2xl text-lg lg:col-span-7" data-id="element-969" data-mp="2plg1plinix2d">
            {article.sections.map(s => <section key={s.heading} data-id="element-970" data-mp="2tmjiqbcfqz56">
                <h2 data-id="element-971" data-mp="2tl8d05zfjhbf">{s.heading}</h2>
                {s.paragraphs.map(p => <p key={p.slice(0, 24)} data-id="element-972" data-mp="r9suq7nwszb">{p}</p>)}
              </section>)}
            <p className="!mt-12 border-t border-line pt-6 !text-sm" data-id="element-973" data-mp="3ry2prhvfa5y1">
              This article is original sample content prepared for the Corventa website and contains no third-party research or quotations.
            </p>
          </article>
        </div>
      </section>
      <section className="bg-ivory py-20" data-id="element-974" data-mp="3dyb8975p67fa">
        <div className="container-page" data-id="element-975" data-mp="3dzcve9zzmkdd">
          <h2 className="font-display text-4xl font-semibold text-ink" data-id="element-976" data-mp="390jgqe8ysnbm">Related articles</h2>
          <div className="mt-10 grid gap-10 md:grid-cols-3" data-id="element-977" data-mp="3mzj6jp87r89d">
            {related.map(a => <ArticleCard key={a.slug} article={a} data-id="element-978" data-mp="3iyfqp2q61c85" />)}
          </div>
          <div className="mt-16 rounded-xl bg-white p-8 md:p-10" data-id="element-979" data-mp="3j0k36924rjk1">
            <h2 className="font-display text-3xl font-semibold text-ink" data-id="element-980" data-mp="127z6rxw8nucl">Subscribe to Corventa insights</h2>
            <div className="mt-6 max-w-2xl" data-id="element-981" data-mp="y7p0sl8g53xq">
              <NewsletterForm tone="light" data-id="element-982" data-mp="15qya6egyd2ms" />
            </div>
          </div>
        </div>
      </section>
    </>;
}